import { useParams } from "react-router-dom";
import {
    RightHeadDecoration,
    LeftHeadDecoration,
} from "../../../../../styles/main/MainCommonStyles";
import { CFlex, CMargin, DText, Flex } from "../../../../../styles/CommonStyles";
import DetailsLayout from "../../../../layout/main/DetailsLayout";
import {
    TradeAmount,
    TradeTypeBadge
} from "../../../../../styles/main/orders";
import { formatDate, formatNumber } from "../../../../../core/utils/common";
import { useMainContext } from "../../../../../core/contexts/main";
import { useGetACardTransfer } from "../../../../../core/services/react-query/report/cards";
import CoinRow from "../../../../common/common/CoinRow";


const CardTransferDetails = () => {

    const { lang } = useMainContext();
    const params = useParams();

    const {
        data: transfer,
        isFetching,
        isError
    } = useGetACardTransfer(params.detailId);


    const isIn = transfer?.type === "in";


    return (
        <DetailsLayout
            isFetching={isFetching}
            isError={isError}
        >

            <RightHeadDecoration>
                <CoinRow
                    coin={{
                        id: transfer?.currency?.toLowerCase()
                    }}
                />
            </RightHeadDecoration>


            <LeftHeadDecoration left="10px">
                <DText main>
                    {transfer?.referenceId}
                </DText>
            </LeftHeadDecoration>


            <DText fontSize="b" primary>
                Card Transfer
            </DText>


            <Flex justify="space-between" wrap>

                <CFlex
                    width="100%"
                    style={{
                        minWidth: "320px",
                        gap: "6px"
                    }}
                >

                    <CMargin margin="8px" />


                    <Flex
                        fw
                        style={{ flexDirection: "row-reverse" }}
                        justify="space-between"
                    >
                        <DText primary>
                            User
                        </DText>

                        <DText primary>
                            {transfer?.user?.email}
                        </DText>
                    </Flex>


                    <CMargin margin="6px" />


                    <Flex
                        fw
                        style={{ flexDirection: "row-reverse" }}
                        justify="space-between"
                    >
                        <DText primary>
                            Type
                        </DText>

                        <TradeTypeBadge
                            color={isIn ? "#10b981" : "#ef4444"}
                        >
                            {transfer?.type}
                        </TradeTypeBadge>

                    </Flex>


                    <CMargin margin="6px" />


                    <Flex
                        fw
                        style={{ flexDirection: "row-reverse" }}
                        justify="space-between"
                    >
                        <DText primary>
                            Amount
                        </DText>

                        <TradeAmount
                            type={isIn ? "buy" : "sell"}
                        >
                            {formatNumber(transfer?.amount)}
                        </TradeAmount>

                    </Flex>


                    <CMargin margin="6px" />


                    <Flex
                        fw
                        style={{ flexDirection: "row-reverse" }}
                        justify="space-between"
                    >
                        <DText primary>
                            Currency
                        </DText>

                        <DText primary>
                            {transfer?.currency}
                        </DText>

                    </Flex>


                    <CMargin margin="6px" />


                    <Flex
                        fw
                        style={{ flexDirection: "row-reverse" }}
                        justify="space-between"
                    >
                        <DText primary>
                            Status
                        </DText>

                        <TradeTypeBadge
                            color={
                                transfer?.status === "success"
                                    ? "success"
                                    : transfer?.status === "pending"
                                        ? "warning"
                                        : "danger"
                            }
                        >
                            {transfer?.status}
                        </TradeTypeBadge>

                    </Flex>


                    <CMargin margin="6px" />


                    <Flex
                        fw
                        style={{ flexDirection: "row-reverse" }}
                        justify="space-between"
                    >
                        <DText primary>
                            Account ID
                        </DText>

                        <DText primary>
                            {transfer?.accountId}
                        </DText>

                    </Flex>


                    <CMargin margin="6px" />


                    <Flex
                        fw
                        style={{ flexDirection: "row-reverse" }}
                        justify="space-between"
                    >
                        <DText primary>
                            Card ID
                        </DText>

                        <DText primary>
                            {transfer?.refCardId}
                        </DText>

                    </Flex>


                    <CMargin margin="6px" />


                    <Flex
                        fw
                        style={{ flexDirection: "row-reverse" }}
                        justify="space-between"
                    >
                        <DText primary>
                            Reference ID
                        </DText>

                        <DText primary>
                            {transfer?.referenceId}
                        </DText>

                    </Flex>

                </CFlex>

            </Flex>


            <Flex
                fw
                justify="space-between"
                style={{ marginTop: 20 }}
            >

                <DText main>
                    {formatDate(transfer?.createdAt, "date", lang)}
                </DText>

                <DText main>
                    {formatDate(transfer?.createdAt, "time", lang)}
                </DText>

            </Flex>


        </DetailsLayout>
    );
};


export default CardTransferDetails;